/* Fairfume theme */
(function(){
  // 18+ check
  (function(){
    var g=document.getElementById('AgeGate');if(!g)return;
    var ok=false;try{ok=localStorage.getItem('fairfume_age_ok')==='1';}catch(e){}
    if(ok)return;
    g.hidden=false;document.body.classList.add('age-open');
    var yes=g.querySelector('[data-age-yes]');if(yes)yes.focus();
    g.addEventListener('click',function(e){
      if(e.target.closest('[data-age-yes]')){try{localStorage.setItem('fairfume_age_ok','1');}catch(err){}g.hidden=true;document.body.classList.remove('age-open');}
      if(e.target.closest('[data-age-no]')){g.querySelector('[data-age-msg]').hidden=false;}
    });
  })();

  // mobiel menu (paneel links)
  var toggle=document.querySelector('.menu-toggle');
  function setMenu(o){document.body.classList.toggle('menu-open',o);if(toggle)toggle.setAttribute('aria-expanded',o);}
  if(toggle){toggle.addEventListener('click',function(){setMenu(!document.body.classList.contains('menu-open'));});}
  document.querySelectorAll('[data-menu-close]').forEach(function(b){b.addEventListener('click',function(){setMenu(false);});});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')setMenu(false);});

  // review carousels
  document.querySelectorAll('.reviews').forEach(function(sec){
    var t=sec.querySelector('.track');if(!t)return;
    sec.querySelectorAll('[data-dir]').forEach(function(b){
      b.addEventListener('click',function(){
        var r=t.querySelector('.review');var step=r?r.offsetWidth+16:300;
        t.scrollBy({left:step*(+b.dataset.dir),behavior:'smooth'});
      });
    });
  });

  // geld formatteren volgens de winkelinstelling
  function formatMoney(cents){
    var fmt=(window.theme&&theme.moneyFormat)||'€{{amount_with_comma_separator}}';
    function d(n,p,t,dc){n=(n/100).toFixed(p);var s=n.split('.');return s[0].replace(/\B(?=(\d{3})+(?!\d))/g,t)+(s[1]?dc+s[1]:'');}
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
      switch(k){
        case 'amount':return d(cents,2,',','.');
        case 'amount_no_decimals':return d(cents,0,',','.');
        case 'amount_with_comma_separator':return d(cents,2,'.',',');
        case 'amount_no_decimals_with_comma_separator':return d(cents,0,'.',',');
        case 'amount_with_apostrophe_separator':return d(cents,2,"'",'.');
        default:return d(cents,2,'.',',');
      }
    });
  }

  // toast + teller
  var toast=document.getElementById('toast');
  function showToast(msg){
    if(!toast)return;document.getElementById('toastText').textContent=msg;
    toast.classList.add('show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('show')},3200);
  }
  function setCount(n){var b=document.getElementById('cartCount');if(!b)return;b.textContent=n;b.classList.toggle('show',n>0);}

  // ---------- cart drawer ----------
  var TTCart=(function(){
    function el(){return document.getElementById('CartDrawer');}
    function open(){document.body.classList.add('drawer-open');var x=el()&&el().querySelector('.drawer-x');if(x)x.focus();}
    function close(){document.body.classList.remove('drawer-open');}
    function loading(on){var d=el();if(d)d.classList.toggle('is-loading',on);}
    function render(sections){
      if(!sections||!sections['cart-drawer'])return;
      var doc=new DOMParser().parseFromString(sections['cart-drawer'],'text/html');
      var fresh=doc.getElementById('CartDrawer'),old=el();
      if(fresh&&old){old.replaceWith(fresh);setCount(+fresh.dataset.count||0);syncExtras(fresh);tickTimer();}
    }
    // losse extra's opruimen en mystery gift toevoegen/verwijderen
    function syncExtras(d){
      if(!d||syncExtras._busy)return;
      var orphan=+d.dataset.upsellOrphan||0,ma=d.dataset.mysteryAction,mv=+d.dataset.mysteryVariant||0,ml=+d.dataset.mysteryLine||0,p=null;
      if(ma==='remove'&&ml)p=change(ml,0);
      else if(orphan>0)p=change(orphan,0);
      else if(ma==='add'&&mv)p=post(theme.cartAddUrl,{items:[{id:mv,quantity:1}]});
      else if(ma==='fix'&&ml)p=change(ml,1);
      if(!p){syncExtras._n=0;return;}
      syncExtras._n=(syncExtras._n||0)+1;if(syncExtras._n>4)return; // nooit eindeloos blijven proberen
      syncExtras._busy=true;
      p.catch(function(err){if(window.console)console.warn('Fairfume: extra product kon niet worden bijgewerkt',err);}).finally(function(){syncExtras._busy=false;syncExtras(el());});
    }
    // reserveringstimer
    var TKEY='fairfume_cart_timer';
    function tickTimer(){
      var t=document.querySelector('[data-cart-timer]');if(!t)return;
      var mins=+t.dataset.minutes||10,start=0,now=Date.now();
      try{start=+sessionStorage.getItem(TKEY)||0;}catch(e){}
      if(!start||now-start>=mins*60000){start=now;try{sessionStorage.setItem(TKEY,start);}catch(e){}}
      var left=Math.max(0,Math.ceil((mins*60000-(now-start))/1000));
      var m=Math.floor(left/60),s=left%60;
      var out=t.querySelector('[data-timer-left]');if(out)out.textContent=m+':'+(s<10?'0':'')+s;
    }
    setInterval(tickTimer,1000);
    function boot(){tickTimer();syncExtras(el());}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
    function post(url,body){
      body.sections=['cart-drawer'];
      loading(true);
      return fetch(url+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;})})
        .then(function(res){render(res.sections);return res;})
        .catch(function(err){showToast((err&&err.description)||'Er ging iets mis, probeer het opnieuw');throw err;})
        .finally(function(){loading(false);});
    }
    function change(line,qty){return post(theme.cartChangeUrl,{line:+line,quantity:Math.max(0,+qty)});}
    function add(items){return post(theme.cartAddUrl,{items:items}).then(function(res){open();return res;});}

    document.addEventListener('click',function(e){
      var t=e.target;
      if(t.closest('[data-cart-open]')&&el()){e.preventDefault();open();return;}
      if(t.closest('[data-drawer-close]')){close();return;}
      var b=t.closest('#CartDrawer [data-line]:not(input)');
      if(b){e.preventDefault();change(b.dataset.line,b.dataset.qty);}
    });
    document.addEventListener('change',function(e){
      var t=e.target;
      // parfumkeuze in de upsell
      if(t.matches&&t.matches('[data-upsell-variant]')){
        var box=t.closest('[data-upsell]');var tg=box&&box.querySelector('[data-upsell-toggle]');if(!tg)return;
        var img=box.querySelector('.d-upsell-img img');if(img&&t.dataset.img){img.src=t.dataset.img;img.removeAttribute('srcset');}
        tg.dataset.variant=t.value;
        if(tg.checked&&+tg.dataset.line>0){
          post(theme.cartChangeUrl,{line:+tg.dataset.line,quantity:0})
            .then(function(){return post(theme.cartAddUrl,{items:[{id:+t.value,quantity:1}]});}).catch(function(){});
        }
        return;
      }
      var tg2=t.closest&&t.closest('[data-upsell-toggle]');
      if(!tg2)return;
      if(tg2.checked)post(theme.cartAddUrl,{items:[{id:+tg2.dataset.variant,quantity:1}]}).catch(function(){tg2.checked=false;});
      else if(+tg2.dataset.line>0)change(tg2.dataset.line,0).catch(function(){tg2.checked=true;});
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&document.body.classList.contains('drawer-open'))close();});
    return {open:open,close:close,add:add,change:change};
  })();
  window.TTCart=TTCart;

  // klantvideo's in een pop-up
  (function(){
    var modal=document.querySelector('[data-ugc-modal]');if(!modal)return;
    var slot=modal.querySelector('[data-ugc-slot]');
    function close(){var v=slot.querySelector('video');if(v)v.pause();slot.innerHTML='';modal.classList.remove('open');modal.setAttribute('aria-hidden','true');}
    document.addEventListener('click',function(e){
      var tile=e.target.closest('[data-ugc]');
      if(tile){
        var src=tile.querySelector('video');if(!src)return;
        var v=src.cloneNode(true);v.muted=false;v.controls=true;v.loop=false;v.removeAttribute('muted');v.setAttribute('playsinline','');
        slot.innerHTML='';slot.appendChild(v);modal.classList.add('open');modal.setAttribute('aria-hidden','false');
        var p=v.play();if(p&&p.catch)p.catch(function(){});
        return;
      }
      if(e.target.closest('[data-ugc-close]'))close();
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('open'))close();});
  })();

  // productpagina
  var section=document.querySelector('[data-product-section]');
  if(!section)return;

  // galerij
  var slides=[].slice.call(section.querySelectorAll('#stage .slide'));
  var thumbs=[].slice.call(section.querySelectorAll('.thumb'));
  var cur=Math.max(0,slides.findIndex(function(s){return s.classList.contains('active')}));
  function show(i){
    if(!slides.length)return;
    cur=(i+slides.length)%slides.length;
    slides.forEach(function(s,k){s.classList.toggle('active',k===cur)});
    thumbs.forEach(function(t,k){t.classList.toggle('active',k===cur)});
  }
  thumbs.forEach(function(t,k){t.addEventListener('click',function(){show(k)})});
  section.querySelectorAll('#stage [data-step]').forEach(function(b){b.addEventListener('click',function(){show(cur+(+b.dataset.step))})});
  // swipen op mobiel
  var stageEl=section.querySelector('#stage'),sx=null,sy=null;
  if(stageEl){
    stageEl.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
    stageEl.addEventListener('touchend',function(e){
      if(sx===null)return;var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))show(cur+(dx<0?1:-1));sx=null;
    },{passive:true});
  }

  // varianten + bundels (bundel = aantal stuks van dezelfde variant)
  var data=JSON.parse(section.querySelector('[data-product-json]').textContent);
  var form=section.querySelector('[data-product-form]');
  var idInput=section.querySelector('[data-variant-id]');
  var qtyInput=section.querySelector('[data-qty-input]');
  var btn=section.querySelector('[data-add-button]');
  var btnText=section.querySelector('[data-add-text]');
  var optInputs=[].slice.call(section.querySelectorAll('[data-opt-input]'));
  var cards=[].slice.call(section.querySelectorAll('.bcard'));
  var addon=section.querySelector('[data-addon-input]');

  function checkedVal(list){var c=list.find(function(i){return i.checked});return c?c.value:null;}
  function selectedOptions(){
    var sel=[];
    for(var i=1;i<=data.optionCount;i++){
      var c=optInputs.find(function(x){return x.dataset.optInput==i&&x.checked});
      sel.push(c?c.value:null);
    }
    return sel;
  }
  function currentVariant(){
    if(!optInputs.length)return data.variants[0];
    var sel=selectedOptions();
    return data.variants.find(function(v){return sel.every(function(o,i){return o===null||v.options[i]===o;});});
  }
  function stock(v){
    var inv=data.inventory[v.id];
    if(!inv||inv.m!=='shopify'||inv.p!=='deny')return null;
    return inv.q;
  }
  function selectedCard(){return cards.find(function(c){return c.querySelector('input').checked});}

  function refreshCards(v){
    var q=v?stock(v):null;
    cards.forEach(function(card){
      var input=card.querySelector('input');
      var qty=+card.dataset.qty,free=+card.dataset.free,paid=qty-free;
      var always=card.dataset.always==='1';
      var left=(q===null||always)?Infinity:Math.floor(q/qty);
      var ribbon=card.dataset.ribbon||'',state='normal';
      if(card.dataset.manualSoldout==='1'||!v||(!always&&!v.available)||left<1){state='soldout';ribbon='Uitverkocht';}
      else if(+card.dataset.remaining>0){state='low';ribbon='Nog maar '+card.dataset.remaining+' beschikbaar';}
      else if(left<=+card.dataset.low){state='low';ribbon='Nog maar '+left+' beschikbaar';}
      card.classList.toggle('is-soldout',state==='soldout');
      input.disabled=state==='soldout';
      if(state==='soldout')input.checked=false;
      var r=card.querySelector('[data-ribbon-el]');
      r.className='ribbon ribbon-'+state;r.textContent=ribbon;r.hidden=!ribbon;
      if(v){
        var gifts=+card.dataset.gifts||0,pr=v.price*paid,cmp=(free>0?v.price*qty:pr)+gifts,sv=cmp-pr;
        card.querySelector('[data-price]').textContent=formatMoney(pr);
        var ce=card.querySelector('[data-compare]');ce.textContent=formatMoney(cmp);ce.hidden=sv<=0;
        var se=card.querySelector('[data-save]');se.hidden=sv<=0;
        card.querySelector('[data-save-pct]').textContent=cmp>0?Math.floor(sv*100/cmp):0;
      }
    });
    if(cards.length&&!selectedCard()){var first=cards.find(function(c){return !c.querySelector('input').disabled});if(first)first.querySelector('input').checked=true;}
  }

  function deliveryDay(){
    var d=new Date();
    if(d.getHours()>=data.cutoffHour)d.setDate(d.getDate()+1);
    var left=data.deliveryDays;
    while(left>0){d.setDate(d.getDate()+1);if(d.getDay()!==0)left--;}
    var t=new Date();t.setHours(0,0,0,0);var diff=Math.round((new Date(d.getFullYear(),d.getMonth(),d.getDate())-t)/864e5);
    if(diff===1)return 'morgen';
    return ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'][d.getDay()];
  }

  function update(){
    var v=currentVariant();
    refreshCards(v);
    selectedOptions().forEach(function(o,i){var l=section.querySelector('[data-opt-label="'+(i+1)+'"]');if(l&&o)l.textContent=o;});
    var card=selectedCard();
    var status=section.querySelector('[data-delivery-status]');
    var cardAlways=card&&card.dataset.always==='1';
    if(!v||(!v.available&&!cardAlways)||(cards.length&&!card)){
      btn.disabled=true;btnText.textContent='Uitverkocht';
      if(status){status.classList.add('out');status.querySelector('[data-stock-text]').textContent='Uitverkocht';}
      return;
    }
    var qty=card?+card.dataset.qty:1,free=card?+card.dataset.free:0;
    idInput.value=v.id;qtyInput.value=qty;
    var total=v.price*(qty-free)+(addon&&addon.checked?+addon.dataset.addonPrice:0);
    btn.disabled=false;btnText.textContent='In mijn mandje – '+formatMoney(total);
    if(status){
      status.classList.remove('out');
      status.querySelector('[data-stock-text]').textContent='Op voorraad';
      status.querySelector('[data-ship-word]').textContent=total>=data.freeShippingFrom?'gratis levering':'levering';
      status.querySelector('[data-delivery-day]').textContent=deliveryDay();
    }
    if(v.featured_media){
      var idx=slides.findIndex(function(s){return s.dataset.mediaId==v.featured_media.id});
      if(idx>-1)show(idx);
    }
    if(optInputs.length){var url=new URL(window.location.href);url.searchParams.set('variant',v.id);window.history.replaceState({},'',url.toString());}
  }
  // sticky knop
  var sticky=document.querySelector('[data-sticky-atc]');
  var saBtn=sticky&&sticky.querySelector('[data-sa-btn]');
  var saText=sticky&&sticky.querySelector('[data-sa-text]');
  function syncSticky(){if(!sticky)return;saText.textContent=btnText.textContent;saBtn.disabled=btn.disabled;}
  if(sticky){
    new MutationObserver(syncSticky).observe(btnText,{childList:true,characterData:true,subtree:true});
    new MutationObserver(syncSticky).observe(btn,{attributes:true,attributeFilter:['disabled']});
    saBtn.addEventListener('click',function(){if(form.requestSubmit)form.requestSubmit();else btn.click();});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        var e=entries[0];var past=!e.isIntersecting&&e.boundingClientRect.top<0;
        sticky.classList.toggle('show',past);sticky.setAttribute('aria-hidden',!past);saBtn.tabIndex=past?0:-1;
      }).observe(btn);
    }
    syncSticky();
  }
  optInputs.forEach(function(i){i.addEventListener('change',update)});
  cards.forEach(function(c){c.querySelector('input').addEventListener('change',update)});
  if(addon)addon.addEventListener('change',update);
  update();

  // toevoegen aan winkelwagen zonder pagina te verlaten
  form.addEventListener('submit',function(e){
    e.preventDefault();
    btn.disabled=true;
    var qty=+qtyInput.value||1;
    var item={id:+idInput.value,quantity:qty};
    var sc=selectedCard();if(sc&&sc.dataset.property)item.properties={'Cadeau':sc.dataset.property};
    var items=[item];
    if(addon&&addon.checked)items.push({id:+addon.value,quantity:1});
    TTCart.add(items).catch(function(){}).finally(function(){update();});
  });
})();

/* aanbiedingstimer op de productpagina (verdwijnt na de einddatum) */
(function(){
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var raw=(el.dataset.countdown||'').trim().replace(' ','T');
    var end=new Date(raw);if(isNaN(end))return;
    var out=el.querySelector('[data-countdown-text]');
    function p(n){return n<10?'0'+n:n;}
    function tick(){
      var s=Math.floor((end-new Date())/1000);
      if(s<=0){el.hidden=true;clearInterval(iv);return;}
      var d=Math.floor(s/86400);s%=86400;
      var h=Math.floor(s/3600),m=Math.floor(s%3600/60),sec=s%60;
      out.textContent=(d>0?d+'d ':'')+p(h)+':'+p(m)+':'+p(sec);
      el.hidden=false;
    }
    var iv=setInterval(tick,1000);tick();
  });
})();
